/**
 * @Author: WangZhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:05:44
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageTic.js
 * @Description: 昊天镜杀毒引擎
 */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import {fetchGetServices, fetchBsbCheck} from '../../actions/productAction';
import {fetchInstanceGetInstance} from '../../actions/buyAction';

class PageTic extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object,
        fetchBsbCheck: PropTypes.func,
        fetchInstanceGetInstance: PropTypes.func,
        fetchGetServices: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            serverData: [],
            resObj: {},
            error: false,
            resRrl: '',
            inputVal: ''
        };
    }

    componentDidMount() {
    }

    render() {
        const bannerInfo = this.props.bannerInfo || {};

        return (
            <div className={'product'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    {bannerInfo.bannerNote}
                </div>

                <div className={'product-mod mt100'}>
                    <ProductTitle title={'产品特色'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTic/icon_cq.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>超强查杀能力</div>
                            <div className={'proinfo-box-des'}>
                                杀毒能力在国际国内多项权威评测中均取得过多次优异成绩。
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTic/icon_dx.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>高性能低占用</div>
                            <div className={'proinfo-box-des'}>
                                扫描时资源占用优于行业表现，不会为客户端或服务器带来额外负荷。
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTic/icon_gx.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>多形态服务方案</div>
                            <div className={'proinfo-box-des'}>
                                包含客户端及服务端解决方案，支持联网与断网环境下查杀，也可上传样本或MD5至云端进行云查。
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'}/>
                </div>

                <div className={'product-mod'}>
                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageTic/pic_kehu.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            客户端SDK
                        </div>
                        <div className={'pro-app-content'}>
                            {'本地扫：支持在断网环境下对终端设备的文件进行查杀。云扫+本地扫：支持通过连接到云端进行病毒查杀，'
                            + '提供更加实时强大的病毒查杀能力。'}
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageTic/pic_fuwu.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            服务端扫描引擎
                        </div>
                        <div className={'pro-app-content'}>
                            {'通过一键部署安装包一键部署到后台,实现本地扫+云扫的反病毒检测能力。满足企业云盘等多'
                            + '场景安全需求，提供全方位数据保护。'}
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageTic/pic_quanping.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            全平台解决方案
                        </div>
                        <div className={'pro-app-content'}>
                            {'服务端通过一键部署安装包一键部署到后台,客户端通过合入SDK实现全平台的反病毒检测能力。'
                            + '查杀快，检出率高，资源占用低。'}
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'部署方式'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>本地查杀能力</div>
                            <div className={'profun-box-des'}>
                                {'支持在断网情况下对设备上的本地文件进行病毒查杀，可进行全盘扫描或根据指定文件路径输出扫描结果，'
                                + '扫描结果包含病毒类型及描述等详细信息。终端查杀能力适合高数据保密性业务场景或终端无法连接到网络的'
                                + '业务场景。'}
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>公有云部署查杀</div>
                            <div className={'profun-box-des'}>
                                {'支持通过互联网连接到云端进行病毒云扫查杀。云查提供了更加实时强大的病毒查杀能力。'
                                + '该能力适用于对安全实时性要求较高、终端可以直接连接到互联网的应用场景。'}
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>私有化部署</div>
                            <div className={'profun-box-des'}>
                                {'支持在局域网环境下的查杀。可以在提供实时病毒查杀能力的同时，降低私有数据泄漏的风险。'
                                + '适合高数据敏感性的客户选择使用。'}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchBsbCheck: obj => fetchBsbCheck(obj),
        fetchGetServices: json => fetchGetServices(json),
        fetchInstanceGetInstance: () => fetchInstanceGetInstance(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTic);



// WEBPACK FOOTER //
// ./src/containers/product/pageTic.js